/* eslint-disable no-underscore-dangle */
/* eslint-disable @next/next/no-assign-module-variable */
import { useEffect, useState } from 'react';

import { DxpAuthenticationSdk } from '@decurtis/dxp-authentication-sdk';

import { useEnvContext } from '@/helpers/envUtils';

export const isAuthAvailable = typeof window !== 'undefined';

let AuthInstance: DxpAuthenticationSdk | null = null;

const copyStaticProps = (Class: any) => {
  const staticProps: Record<string, any> = {};
  Object.getOwnPropertyNames(Class).forEach((key) => {
    staticProps[key] = Class[key]; // Copy both properties and methods
  });
  return staticProps;
};

export const useAuth = () => {
  const { AUTHENTICATION_BASE_URL, BASIC_TOKEN } = useEnvContext();
  const [authInstance, setAuthInstance] = useState<DxpAuthenticationSdk | null>(AuthInstance);

  useEffect(() => {
    if (authInstance) {
      return;
    }

    const loadAuth = async () => {
      const module = await import('@decurtis/dxp-authentication-sdk');
      const Auth = module.default;

      Auth.init({ url: AUTHENTICATION_BASE_URL, basicToken: `basic ${BASIC_TOKEN}`, force: true });

      if (window.__DXP_AUTHENTICATION_SDK__) {
        const staticProps = copyStaticProps(window.__DXP_AUTHENTICATION_SDK__);

        AuthInstance = staticProps as DxpAuthenticationSdk;
      }

      setAuthInstance(AuthInstance);
    };

    loadAuth();
  }, [AUTHENTICATION_BASE_URL, BASIC_TOKEN, authInstance]);

  return authInstance;
};
